var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5486 35.6262L14 39.3751L25.7599 51.135C26.997 52.3721 29.0028 52.3721 30.2399 51.135L40.5999 40.7749L35.4512 35.6261C31.0233 38.853 24.9765 38.853 20.5486 35.6262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6 40.7749C51.8 29.575 48.9999 18.3749 42.0001 11.3751C34.268 3.64301 21.7319 3.64307 14 11.375C8.7666 16.6084 4.19992 29.5749 14.0001 39.3751L20.5487 35.6262C16.9372 30.6705 14.5678 20.8873 19.04 16.415C23.9885 11.4665 32.0115 11.4665 36.9601 16.4151C41.4323 20.8872 39.0625 30.6706 35.4512 35.6261L40.6 40.7749Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9881 16.3869C41.952 21.3508 41.952 29.3991 36.9881 34.363C32.0241 39.327 23.976 39.3269 19.0121 34.363C14.0481 29.399 14.0481 21.3509 19.0121 16.3869C23.976 11.4231 32.0241 11.423 36.9881 16.3869Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5001 14.8749C44.299 20.6738 44.2991 30.0759 38.5001 35.8749C32.7011 41.6739 23.299 41.6738 17.5001 35.8749C11.701 30.0758 11.701 20.6738 17.5 14.8748C23.299 9.07578 32.701 9.07582 38.5001 14.8749Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0204 46.9345L18.9354 38.8495L21.6635 36.1214C25.5614 38.4234 30.4393 38.4233 34.3374 36.1213L37.0655 38.8494L28.9804 46.9345C28.4392 47.4758 27.5617 47.4758 27.0204 46.9345Z",
    stroke: "#F46857",
    strokeWidth: 3.26667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4148 36.3394C46.9904 29.5344 46.6022 19.4768 40.2502 13.1248C33.4847 6.3593 22.5156 6.35931 15.7501 13.1248C9.39801 19.4769 9.00985 29.5344 14.5857 36.3394L19.0303 31.8948C15.8702 27.5585 16.2468 21.4481 20.1601 17.5348C24.49 13.2049 31.5103 13.2049 35.8402 17.5348C39.7533 21.4479 40.1299 27.5585 36.97 31.8946L41.4148 36.3394Z",
    fill: "#F46857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.9e61ee3185b7e0d8fe876c0a42e2a7f5.svg";
export { ForwardRef as ReactComponent };